/** ⌘/ — the keyboard shortcuts sheet (core logic/shortcuts SHORTCUTS). */
import { Shortcuts } from "@bundle/core";
import { Sheet, Stack, Text, useT } from "@bundle/ui";

const apple = typeof navigator !== "undefined" && /Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent);

export function ShortcutsSheet({ open, onClose }: { open: boolean; onClose: () => void }) {
  const t = useT();
  return (
    <Sheet open={open} onClose={onClose} title={t("shortcuts.title")} testID="shortcuts-sheet">
      <Stack gap="1" padding="4">
        {Shortcuts.SHORTCUTS.map((s) => (
          <Stack key={s.id} direction="horizontal" align="center" justify="between" gap="4" paddingY="1" testID={`shortcut-${s.id}`}>
            <Text>{t(s.label)}</Text>
            <Stack direction="horizontal" gap="1">
              {Shortcuts.keyCaps(s.keys, apple).map((k, i) => (
                <kbd key={i} className="shortcut-key">
                  {k}
                </kbd>
              ))}
            </Stack>
          </Stack>
        ))}
        <Text variant="headline" weight="semibold">
          {t("shortcuts.mail.title")}
        </Text>
        {Shortcuts.MAIL_SHORTCUTS.map((s) => (
          <Stack key={s.id} direction="horizontal" align="center" justify="between" gap="4" paddingY="1" testID={`shortcut-mail-${s.id}`}>
            <Text>{t(s.label)}</Text>
            <Stack direction="horizontal" gap="1">
              {Shortcuts.keyCaps(s.keys, apple).map((k, i) => (
                <kbd key={i} className="shortcut-key">
                  {k}
                </kbd>
              ))}
            </Stack>
          </Stack>
        ))}
      </Stack>
    </Sheet>
  );
}
